var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69422 0H2.35916C1.48809 0 0.78331 0.675 0.78331 1.5L0.775391 13.5C0.775391 14.325 1.48017 15 2.35124 15H11.8618C12.7328 15 13.4455 14.325 13.4455 13.5V4.5L8.69422 0ZM11.8618 13.5H2.35916V1.5H7.90234V5.25H11.8618V13.5ZM3.94292 9.7575L5.05948 10.815L6.31857 9.63V12.75H7.90234V9.63L9.16144 10.8225L10.278 9.7575L7.11838 6.75L3.94292 9.7575Z",
    fill: "#1E88E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload_file.952e0d1a.svg";
export { ForwardRef as ReactComponent };